import CurrencyField from 'components/ui/CurrencyField';
import { XIcon } from 'components/ui/icons';
import TextField from 'components/ui/TextField';
import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { customStyles } from './Exemptions';
import { Exemption, DropdownOption } from '../../types';
import colors from 'css/colors';

interface PropTypes {
  index: number;
  exemptionTypes: any[];
  addExemption: (e: any, index: number) => void;
  exemption: Exemption;
  taxIndex: number;
  showDelete: boolean;
  changeFunction: (key: string, value: any, index: number, name?: string, exIndex?: number) => void;
  removeFunction: (index: number, key: string, value: any) => void;
}

export const ExemptionPortion = (props: PropTypes) => {
  const [exemptionType, setExemptionType] = useState<DropdownOption>();
  useEffect(() => {
    if (!props.exemption.type?.label || !props.exemption.type?.value) {
      setExemptionType(null);
    } else {
      setExemptionType(props.exemption.type);
    }
  }, [props.exemption.type]);
  return (
    <div
      key={props.index}
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div style={{ width: 295 }}>
        <CreatableSelect
          options={props.exemptionTypes}
          placeholder="Exemption Type"
          onChange={e => props.addExemption(e, props.index)}
          value={exemptionType}
          styles={customStyles}
        />
      </div>
      <CurrencyField
        styles={{ marginLeft: 16, marginBottom: 8 }}
        width="128px"
        placeholder="Savings"
        value={props.exemption.savings !== undefined ? `${props.exemption.savings}` : undefined}
        onChange={(e: any) => props.changeFunction('exemptions', e, props.taxIndex, 'savings', props.index)}
      />
      <TextField
        styles={{ marginLeft: 16 }}
        width="168px"
        placeholder="vs"
        onChange={(e: any) =>
          props.changeFunction('exemptions', e.target.value, props.taxIndex, 'vsText', props.index)
        }
        value={props.exemption.vsText}
      />
      {props.showDelete && (
        <span style={{ marginLeft: 8, cursor: 'pointer' }}>
          <XIcon
            stroke={colors.greyDark}
            onClick={() => props.removeFunction(props.taxIndex, 'exemptions', props.index)}
          />
        </span>
      )}
    </div>
  );
};
